module.exports = __webpack_public_path__ + "img/assign_card.f4b00954.svg";